import { render } from "./MyLeaveList.vue?vue&type=template&id=03498e81"
import script from "./MyLeaveList.vue?vue&type=script&lang=js"
export * from "./MyLeaveList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__